
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'


/**
 * 
 * @prop value              线索列表数据
 * @prop isReport           是否作用于新增报道线索
 * @emit detail             查看详情
 * @emit examineChange      更改审核状态
 * @emit delete             删除
 * @emit report             报道
 * 
*/
@Component({})
export default class LatestClueTable extends Vue {
    @Prop({ required: true }) private value!: any[]
    @Prop({ default: false }) private isReport!: boolean
    private examineOptions = [
        { label: '未审核', value: 0 },
        { label: '通过', value: 1 },
        { label: '不通过', value: 2 }
    ]

    @Emit('detail')
    private onLookDetail(id: number | string) {
        return id
    }

    @Emit('examineChange')
    private onExamineChange(target: any, val: any) {
        return { target, val }
    }

    @Emit('delete')
    private onDelete(id: number | string) {
        return id
    }

    @Emit('report')
    private onReport(clue: any) {
        return clue
    }

    @Emit('changeTop')
    private onChangeTop(status: number, id: number) {
        return { status, id }
    }
}
